import Vue from 'vue';
import VueLocalStorage from 'vue-localstorage';
import { PRIVACY_MODULE_STORE_NAME, SHOW_PRIVACY_CONSENT_COMPONENT } from '../constants';

let localStorageAdapter;

const state = Vue.observable({});

const plugin = {
    get(key) {
        if (Vue.$store.state[PRIVACY_MODULE_STORE_NAME].informationStorageAndAccess) {
            return localStorageAdapter.get(key);
        } else {
            if (state.hasOwnProperty(key) === false) {
                return localStorageAdapter.get(key);
            } else {
                return state[key];
            }
        }
    },
    set(key, value) {
        if (Vue.$store.state[PRIVACY_MODULE_STORE_NAME].informationStorageAndAccess) {
            localStorageAdapter.set(key, value);
        } else {
            state[key] = value;
        }
    },
    remove(key) {
        if (Vue.$store.state[PRIVACY_MODULE_STORE_NAME].informationStorageAndAccess) {
            localStorageAdapter.remove(key);
        } else {
            delete state[key];
        }
    },
};

export default {
    install(Vue, options) {
        VueLocalStorage.install(Vue, options);
        if (Vue.$store.state[PRIVACY_MODULE_STORE_NAME]) {
            localStorageAdapter = Vue.localStorage;
            Vue.localStorage = plugin;
            Vue.prototype.$localStorage = plugin;

            Vue.$store.watch(
                () => Vue.$store.state[PRIVACY_MODULE_STORE_NAME].informationStorageAndAccess,
                value => {
                    if (value === true) {
                        Object.keys(state).forEach(key => {
                            plugin.set(key, state[key]);
                        });
                    } else {
                        localStorage.clear();
                    }
                },
                {
                    // immediate: true,
                },
            );
        }
    },
};
